import type { ComponentsArticleReasonsWhyReason } from 'queries/graphql';
import { buildImgProps } from 'utils/media';

import MarkdownText from 'generic/MarkdownText';
import Image from 'next/image';

import styles from './styles.module.sass';
import useMobileDetect from 'hooks/useMobileDetect';

export function ReasonWhy(reason: ComponentsArticleReasonsWhyReason) {
  const isMobile = useMobileDetect();

  return isMobile ? <ReasonWhyCardMobile {...reason} /> : <ReasonWhyCardDesktop {...reason} />;
}

function ReasonWhyCardDesktop({
  title,
  body,
  thumbnailImage,
  sort,
}: ComponentsArticleReasonsWhyReason) {
  return (
    <div className={styles.row}>
      {thumbnailImage && (
        <Image
          {...buildImgProps(thumbnailImage)}
          alt={thumbnailImage.alt}
          height={325}
          width={325}
          className={styles.thumbnail}
        />
      )}
      <div className={styles.column}>
        <div className={styles.reasonTitle}>
          {sort}. {title}
        </div>
        <MarkdownText text={body} />
      </div>
    </div>
  );
}

function ReasonWhyCardMobile({
  title,
  body,
  thumbnailImage,
  sort,
}: ComponentsArticleReasonsWhyReason) {
  return (
    <div className={styles.row}>
      <div className={styles.column}>
        <div className={styles.reasonTitle}>
          {sort}. {title}
        </div>
        {thumbnailImage && (
          <Image
            {...buildImgProps(thumbnailImage)}
            alt={thumbnailImage.alt}
            height={325}
            width={325}
            className={styles.thumbnail}
          />
        )}
        <MarkdownText text={body} />
      </div>
    </div>
  );
}
